export default __webpack_public_path__ + "static/media/mobile-map.19304f5d.svg";